import toArray from 'lodash/toArray'
// 选择文件
let _callback = null

let form = document.createElement('form')
let input = document.createElement('input')

document.getElementsByTagName('body')[0].appendChild(form)

form.appendChild(input)
form.style.position = 'fixed'
form.style.left = '-10000px'

input.type = 'file'
input.addEventListener('change', change)

/* istanbul ignore next */
function change (event) {
  if (!input.files.length) return
  let files = toArray(input.files)
  form.reset()
  if (input.disabled) return
  _callback && _callback(files, event)
}

export default /* istanbul ignore next */ function (options, callback) {
  input.accept = input.multiple = input.disabled = undefined
  if (!callback) {
    _callback = options
  } else {
    _callback = callback
    if (options.disabled) return
    Object.keys(options).forEach(key => input[key] = options[key])
  }
  input.click()
}



// WEBPACK FOOTER //
// ./src/utils/selectFile.js